/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Button,
  Grid,
  Icon,
  Segment,
  Modal,
} from 'semantic-ui-react';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import { flashErrorMessage } from '../../actions/flash';
import { UnitPackagePricingEdit } from '../../components/ProjectUnitPackagePricing';
import { SortableContainer, SortableDragHandle } from '../../components/Sortable';
import AppForm from '../../components/AppForm';
import DeleteConfirm from '../../containers/modals/DeleteConfirm';
import { PROJECT_UNIT_PACKAGE_PRICING_DEFAULT } from '../../structs/package_pricing';


const SortableItem = SortableElement(props => (
  <div className={`sortablehoc_item ${props.itemClass ? props.itemClass : ''}`}>
    <Segment className="package_pricing_unit">
      <Grid>
        <Grid.Row verticalAlign="middle">
          <Grid.Column mobile={2} tablet={2} computer={1}>
            <SortableDragHandle {...props} />
          </Grid.Column>
          <Grid.Column mobile={11} tablet={12} computer={14}>
            <UnitPackagePricingEdit
              {...props}
              data={props.value}
              packagePricings={props.packagePricings}
              onChange={props.onChange}
              refValidation={props.refValidation}
              refForm={props.refForm}
            />
          </Grid.Column>
          <Grid.Column mobile={3} tablet={2} computer={1} textAlign="right">
            <Button
              size="small"
              basic
              compact
              icon
              onClick={() => props.onDelete(props.value)}
            >
              <Icon name="trash" color="red" />
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
));

export default class MultiUnitPackagePricing extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.array]),
    onChange: PropTypes.func.isRequired,
    onDone: PropTypes.func,
    open: PropTypes.bool,
    packagePricings: PropTypes.oneOfType([PropTypes.array]).isRequired,
    unit: PropTypes.oneOfType([
      PropTypes.object.isRequired,
    ]),
  }
  static getPropsToState = (props) => {
    const data = props.unit && props.unit.projectUnitPackagePricings ? props.unit.projectUnitPackagePricings : props.data || [];
    const packagePricings = props.packagePricings || [];
    return {
      data,
      packagePricings,
    };
  }
  constructor(props) {
    super(props);
    const state = MultiUnitPackagePricing.getPropsToState(props);
    this.state = {
      ...state,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
    };
    this.editRef = [];
    this.formRef = {};
  }
  componentWillReceiveProps(nextProps) {
    const state = MultiUnitPackagePricing.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const data = this.sortDataByIndex(arrayMove(this.state.data, oldIndex, newIndex));
    this.setState({ data });
  };
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  getPackagePricings = () => {
    const { data } = this.state;
    // filter out already added package pricings
    const packagePricings = this.state.packagePricings.filter(p => !data.find(d => d.id !== '' && d.projectPackagePricingID === p.id)).sort((a, b) => a.orderPriority - b.orderPriority);
    const options = [];
    packagePricings.forEach((p) => {
      const newItem = {
        text: p.name,
        value: p.id,
      };
      // disabled the option once selected
      const selectedItem = data.find(d => d.projectPackagePricingID === p.id);
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  }
  setRefValidation = (ref, idx) => {
    if (ref && ref.props && ref.props.name) {
      if (!this.editRef[idx]) this.editRef[idx] = {};
      this.editRef[idx][ref.props.name] = ref;
    }
  }
  setRefForm = (ref) => {
    this.formRef = ref;
  }
  sortDataByIndex = (newData) => {
    const data = newData;
    data.forEach((d, index) => {
      data[index].orderPriority = index + 1;
    });
    return data;
  }
  asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index += 1) {
      await callback(array[index], index, array);
    }
  }
  handleOnChange = (d, idx) => {
    const { data } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    this.setState({ data: newData }, async () => {
      if (this.editRef[idx]) AppForm.validate(this.editRef[idx], newData[idx]);
      if (this.props.onChange) {
        if (!this.props.unit) {
          let hasError = false;
          let errMessages = '';
          await this.asyncForEach(data, async (db, idxb) => {
            if (this.editRef[idxb] && !hasError) {
              const validations = await AppForm.validate(this.editRef[idxb], data[idxb]);
              errMessages = validations.filter(v => !v.isValid);
              if (errMessages.length > 0) {
                hasError = true;
              }
            }
          });
          this.props.onChange(this.state.data, errMessages);
          return;
        }
        this.props.onChange(this.state.data);
      }
    });
  }
  handleDelete = (d, idx) => {
    this.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
    });
  }
  handleConfirmDelete = async (e) => {
    e.preventDefault();
    const { data, deleteIDX } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    this.setState({
      data: this.sortDataByIndex(newData),
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
      deleteIDX: null,
      showDeleteConfirm: false,
    }, () => {
      if (this.props.onChange) this.props.onChange(this.state.data);
    });
  }
  handleAdd = (e) => {
    e.preventDefault();
    const { data } = this.state;
    const { unit } = this.props;
    const newItem = clone(Object.assign({}, PROJECT_UNIT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1,
      projectID: unit ? unit.projectID : '',
      projectUnitID: unit ? unit.id : '',
    }));
    data.push(newItem);
    this.setState({ data }, async () => {
      if (this.props.onChange) {
        if (!this.props.unit) {
          let hasError = false;
          let errMessages = '';
          await this.asyncForEach(data, async (db, idxb) => {
            if (this.editRef[idxb] && !hasError) {
              const validations = await AppForm.validate(this.editRef[idxb], data[idxb]);
              errMessages = validations.filter(v => !v.isValid);
              if (errMessages.length > 0) {
                hasError = true;
              }
            }
          });
          this.props.onChange(this.state.data, errMessages);
          return;
        }
        this.props.onChange(this.state.data);
      }
    });
  }
  handleOnDone = async (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { data } = this.state;
    let hasError = false;
    await this.asyncForEach(data, async (d, idx) => {
      if (this.editRef[idx] && !hasError) {
        const validations = await AppForm.validate(this.editRef[idx], data[idx]);
        const errMessages = validations.filter(v => !v.isValid);
        if (errMessages.length > 0) {
          hasError = true;
          await store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errMessages.map(l => l.message) }));
        }
      }
    });
    if (!hasError && this.props.onDone) {
      this.props.onDone(e);
    }
  }
  renderEdit() {
    const {
      data,
      showDeleteConfirm,
    } = this.state;
    return (
      <div>
        <DeleteConfirm
          content="Are you sure you want to remove this unit pricing package?"
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          open={showDeleteConfirm}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {data.length > 0 ? (
                <SortableContainer
                  isSortMode
                  iconColor="blue"
                  helperClass="sorting"
                  data={data}
                  lockAxis="y"
                  lockToContainerEdges
                  onSortEnd={this.onSortEnd}
                  useDragHandle
                  item={props => (
                    <SortableItem
                      {...props}
                      onChange={d => this.handleOnChange(d, props.idx)}
                      onDelete={d => this.handleDelete(d, props.idx)}
                      refForm={this.setRefForm}
                      refValidation={ref => this.setRefValidation(ref, props.idx)}
                      packagePricings={this.getPackagePricings}
                    />
                  )}
                />
              ) : (
                <Segment className="segment_unit_pricing_package_not_found" textAlign="center">No unit pricing package found</Segment>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row textAlign="center">
            <Grid.Column width={16}>
              <Button
                basic
                onClick={this.handleAdd}
              >
                <Icon name="add circle" color="green" /> Add pricing package
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
  render() {
    const {
      unit,
    } = this.props;
    if (unit) {
      return (
        <Modal
          closeOnEscape={false}
          closeOnDimmerClick={false}
          open={this.props.open === true}
        >
          <Modal.Header>Manage Pricing Package for {unit.reference}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {this.renderEdit()}
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button primary onClick={this.handleOnDone} content="Confirm" inverted />
          </Modal.Actions>
        </Modal>
      );
    }
    return this.renderEdit();
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitPackagePricing.jsx